<template>
  <div
    class="modal fade"
    id="LoginModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            id="exampleModalLabel"
												data-test="vendorLoginModalHead"
          >
            Login
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.prevent="resetLoginForm"
												data-test="vendorLoginModalCloseBtn"
												id="vendorLoginModalCloseBtn"
          >
            <span aria-hidden="true"
																		data-test="vendorLoginModalCloseSpan"
																		id="vendorLoginModalCloseSpan">
              &times;
            </span>
          </button>
        </div>

        <div class="modal-body">
          <vendor-login-verification-form
            :email="email"
            :resetFormData="resetVendorLoginForm"
            @vendorVerificationViaPassword="vendorLoginViaPassword($event)"
            @vendorVerificationViaOtp="vendorLoginOtpVerify($event)"
            @vendorLoginOtpRequest="vendorLoginOtpRequest($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VendorLoginVerificationForm from '@/components/pages/vendor/forms/VendorLoginVerificationForm'
import { vendorApis } from '../../../../services/ApiServices/vendorApis'

export default {
	name: 'vendor-login-modal',
	components: {
		VendorLoginVerificationForm
	},
	data () {
		return {
			emailAcct: {
				username: '',
				password: ''
			},
			otpEmail: {
				email: ''
			},
			show: false,
			eventValue: '',
			showLoginError: false,
			otpLogin: {
				otp: ''
			},
			otpSend: false,
			otpNotSend: false,
			selectedVerification: 'Select...',
			resetVendorLoginForm: false
		}
	},
	props: {
		email: null
	},
	methods: {
		vendorLoginViaPassword (emailAcct) {
			vendorApis.newVendorLogin(emailAcct)
				.then((res) => {

				})
				.catch((e) => {
					this.resetLoginForm()
				})
		},
		vendorLoginOtpRequest (email) {
			vendorApis.vendorRequestOtp(email)
				.then((res) => {
					this.$toasted.show(`OTP send to ${email.email}.`, { position: 'bottom-center' })
				})
				.catch((e) => {
					this.$toasted.show('Invalid otp..')
				})
		},
		vendorLoginOtpVerify (otp) {
			vendorApis.vendorLoginViaOtp(otp)
				.then((res) => {

				})
				.catch((e) => {
					this.resetLoginForm()
				})
		},
		resetLoginForm () {
			this.resetVendorLoginForm = true
		}
	}
}
</script>

<style scoped>
</style>
